import React from 'react';
import { FormProvider } from 'react-hook-form';
import CreateEventStep1 from './sections/CreateEventStep1';
import CreateEventStep2 from './sections/CreateEventStep2';
import CreateEventStep3 from './sections/CreateEventStep3';
import ButtonNavigation from './components/ButtonNavigation';
import StepBar from './components/StepBar';
import useEventHosting from './hooks/useEventHosting';
import './style.scss';

const EventHosting = () => {
  const {
    methods,
    currentStep,
    isSubmitting,
    handleNext,
    handleSaveDraft,
    // prevStep,
    goToStep,
    handleCancel,
  } = useEventHosting();

  return (
    <FormProvider {...methods}>
      <div
        className="event-hosting-container"
        style={{
          background: 'rgb(244, 246, 248)',
          minHeight: '100vh',
          paddingBottom: '30px',
        }}
      >
        <StepBar currentStep={currentStep} />
        <div style={{ display: currentStep === 1 ? 'block' : 'none' }}>
          <CreateEventStep1 />
        </div>
        {currentStep === 2 && <CreateEventStep2 />}
        {currentStep === 3 && (
          <CreateEventStep3 goToStep={goToStep} />
        )}
        <div style={{ maxWidth: '600px', margin: '20px auto 0' }}>
          <ButtonNavigation
            currentStep={currentStep}
            onNext={handleNext}
            onCancel={handleCancel}
            onSaveDraft={handleSaveDraft}
            disabledNext={isSubmitting}
            disabledSaveDraft={isSubmitting}
          />
        </div>
      </div>
    </FormProvider>
  );
};

export default EventHosting;
